import axios from 'axios'
// import qs from 'qs'
import { Toast } from 'vant'
import { STATUS_CODE_OK } from "@/config";

let loadingInstace = null

// ajax request
const fetch = axios.create({
  baseURL: process.env.VUE_APP_BACK_END_API_PX_URL,
  withCredentials: true,
  timeout: 10000
})

// request interceptor
fetch.interceptors.request.use(
  config => {
    if (config.url != "/focus/motion/inventory/select_goods_inventory") {
      loadingInstace = Toast.loading({
        mask: true,
        message: '加载中...',
        duration: 0
      })
    }
    config.headers["Content-Type"] = 'application/json;charset=UTF-8';
    if (config.method === 'post') {
      config.data = JSON.stringify(config.data)
    }
    return config
  },
  error => {
    loadingInstace && loadingInstace.clear()
    return Promise.reject(error)
  }
)

fetch.interceptors.response.use(
  res => {
    if (res.data.resultStatusCode !== STATUS_CODE_OK) {
      Toast({
        className: 'error-toast',
        message: res.data.resultStatusMessage,
        position: 'top',
        duration: 3 * 1000
      })
      return Promise.reject(res)
    }
    loadingInstace && loadingInstace.clear()
    return res
  },
  err => {
    loadingInstace && loadingInstace.clear()
    if (err.response) {
      Toast({
        className: 'error-toast',
        message: err.message,
        position: 'top',
        duration: 3 * 1000
      })
    }
    return Promise.reject(err)
  }
)

export default fetch
